export const RelationshipDisplay = {
  REFER_TO: 'Refer To',
  REFERRED_BY: 'Referred By',

  CURRENT_ATTENDANT: 'Current Attendant',
  ATTENDANT: 'Attendant',
  INFORMANT: 'Informant',
  PATIENT: 'Patient',
  PARENT: 'Parent',
  CHILD: 'Child',

  SPOUSE: 'Spouse',

  SIBLING: 'Sibling',

  GRANDPARENT: 'Grandparent',
  GRANDCHILD: 'Grandchild',

  UNCLE: 'Uncle',
  AUNT: 'Aunt',
  NEPHEW: 'Nephew',
  NIECE: 'Niece',
} as const;

export type RelationshipDisplay = (typeof RelationshipDisplay)[keyof typeof RelationshipDisplay];
